import { render, staticRenderFns } from "./HostingBreadcrumbs.vue?vue&type=template&id=44208727&scoped=true&"
import script from "./HostingBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./HostingBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44208727",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44208727')) {
      api.createRecord('44208727', component.options)
    } else {
      api.reload('44208727', component.options)
    }
    module.hot.accept("./HostingBreadcrumbs.vue?vue&type=template&id=44208727&scoped=true&", function () {
      api.rerender('44208727', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/HostingBreadcrumbs.vue"
export default component.exports